import React, { useCallback, useEffect, useRef, useState } from 'react';
import PrivateChat from './PrivateChat';
import { BACKEND_URL } from '@/lib/config';
import { userPictureUrl } from '@/lib/media';
import ImageCropper from './ImageCropper';
import '../store-redesign.css';
const FILTERS = [['all', 'Todos', 'ti-sparkles'], ['image', 'Ilustrações', 'ti-photo'], ['video', 'Vídeos', 'ti-player-play'], ['3d', 'Modelos 3D', 'ti-cube-3d-sphere']];
const money = value => (Number(value || 0) / 100).toLocaleString('pt-BR', {
  style: 'currency',
  currency: 'BRL'
});
const SOFTWARE = [['blender', 'Blender', 'B'], ['unreal', 'Unreal', 'U'], ['mmd', 'MMD', 'M'], ['maya', 'Maya', 'M'], ['photoshop', 'Photoshop', 'Ps'], ['krita', 'Krita', 'K'], ['clipstudio', 'Clip Studio', 'CS'], ['zbrush', 'ZBrush', 'Z'], ['unity', 'Unity', 'U'], ['procreate', 'Procreate', 'P']];
const discount = item => item.compare_at_price_cents ? Math.max(1, Math.round((1 - item.price_cents / item.compare_at_price_cents) * 100)) : 0;
function StoreCard({
  item,
  getMediaUrl,
  onOpen,
  onFavorite
}) {
  const off = discount(item);
  return <article className="store-card" onClick={() => onOpen(item)}><div className="store-card-media">{item.item_type === 'video' ? <video src={getMediaUrl(item.thumbnail_url)} muted playsInline preload="metadata" /> : item.item_type === '3d' && item.thumbnail_url === item.media_url ? <div className="store-model-cover"><i className="ti ti-cube-3d-sphere" /><span>Modelo 3D</span></div> : <img src={getMediaUrl(item.thumbnail_url)} alt={item.title} loading="lazy" />}<span>{item.item_type === '3d' ? '3D' : item.item_type === 'video' ? 'VÍDEO' : 'ARTE'}</span>{off > 0 && <em>-{off}%</em>}</div><div className="store-card-info"><small>@{item.seller?.handle}</small><b>{item.title}</b><p>{item.description || 'Criação da comunidade'}</p>{item.compare_at_price_cents && <del>{money(item.compare_at_price_cents)}</del>}<strong>{money(item.price_cents)}</strong></div><button className={item.is_favorited ? 'active' : ''} onClick={event => {
      event.stopPropagation();
      onFavorite(item);
    }} aria-label="Favoritar"><i className={`ti ${item.is_favorited ? 'ti-heart-filled' : 'ti-heart'}`} /></button></article>;
}
function ListingDetails({
  item,
  getMediaUrl,
  currentUser,
  onClose,
  onFavorite,
  onChat,
  onDeleted,
  onOpenProfile,
  authFetch
}) {
  const license = {
    personal: 'Uso pessoal',
    commercial: 'Uso comercial',
    exclusive: 'Licença exclusiva'
  }[item.license_type] || 'Licença definida';
  const [related, setRelated] = useState([]);
  useEffect(() => {
    authFetch(`${BACKEND_URL}/api/store/listings/${item.listing_id}/view`, {
      method: 'POST'
    }).catch(() => {});
  }, [authFetch, item.listing_id]);
  useEffect(() => {
    authFetch(`${BACKEND_URL}/api/store/listings/${item.listing_id}/related?limit=8`).then(r => r.ok ? r.json() : []).then(d => setRelated(Array.isArray(d) ? d : [])).catch(() => {});
  }, [authFetch, item.listing_id]);
  const remove = async () => {
    if (!window.confirm('Excluir este anúncio da lojinha?')) return;
    const r = await authFetch(`${BACKEND_URL}/api/store/listings/${item.listing_id}`, {
      method: 'DELETE'
    });
    if (r.ok) {
      onDeleted(item.listing_id);
      onClose();
    }
  };
  return <div className="store-modal-backdrop" onClick={event => event.target === event.currentTarget && onClose()}><section className="store-modal"><header><b>{item.title}</b><button onClick={onClose}><i className="ti ti-x" /></button></header><div className="store-modal-media">{item.item_type === 'video' ? <video src={getMediaUrl(item.media_url)} controls autoPlay loop playsInline /> : item.item_type === '3d' ? <div className="store-model-cover"><i className="ti ti-cube-3d-sphere" /><span>Visualização 3D no dispositivo</span></div> : <img src={getMediaUrl(item.media_url)} alt={item.title} />}</div><div className="store-modal-copy"><button className="store-seller" onClick={() => onOpenProfile?.(item.seller_id)}><span>{item.seller?.picture ? <img src={userPictureUrl(item.seller.picture, getMediaUrl)} alt="" /> : <i className="ti ti-user" />}</span><div><b>{item.seller?.name}</b><small>@{item.seller?.handle} · ver perfil</small></div><i className="ti ti-chevron-right" /></button><p>{item.description || 'O artista não adicionou uma descrição.'}</p><div className="store-price"><div>{item.compare_at_price_cents && <del>{money(item.compare_at_price_cents)}</del>}<strong>{money(item.price_cents)}</strong></div><span><i className="ti ti-file-certificate" />{license}</span></div><div className="store-modal-actions">{item.seller_id !== currentUser?.user_id && <button className="primary store-buy"><i className="ti ti-shopping-bag-heart" />Comprar</button>}<button onClick={() => onFavorite(item)} className={item.is_favorited ? 'active' : ''}><i className={`ti ${item.is_favorited ? 'ti-heart-filled' : 'ti-heart'}`} />Favoritar</button>{item.seller_id !== currentUser?.user_id && <button onClick={onChat}><i className="ti ti-message-heart" />Artista</button>}{item.seller_id === currentUser?.user_id && <button className="danger" onClick={remove}><i className="ti ti-trash" />Excluir</button>}</div><small className="store-payment-note"><i className="ti ti-lock" /> Compra protegida em preparação; nenhuma cobrança será feita agora.</small>{related.length > 0 && <section className="store-related"><h3>Você também pode gostar</h3><div>{related.map(x => <article key={x.listing_id}><img src={getMediaUrl(x.thumbnail_url)} alt="" /><span><b>{x.title}</b><small>@{x.seller?.handle}</small><strong>{money(x.price_cents)}</strong></span></article>)}</div></section>}</div></section></div>;
}
function SellPanel({
  authFetch,
  onPublished
}) {
  const [file, setFile] = useState(null);
  const [form, setForm] = useState({
    title: '',
    description: '',
    item_type: 'image',
    price: '',
    comparePrice: '',
    license_type: 'personal',
    tags: ''
  });
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState('');
  const change = (key, value) => setForm(old => ({
    ...old,
    [key]: value
  }));
  const submit = async event => {
    event.preventDefault();
    if (!file) return;
    setBusy(true);
    setNotice('');
    try {
      const cents = Math.round(Number(form.price.replace(',', '.')) * 100);
      const before = form.comparePrice ? Math.round(Number(form.comparePrice.replace(',', '.')) * 100) : null;
      if (!Number.isFinite(cents) || cents < 100) throw new Error('Informe um preço a partir de R$ 1,00.');
      if (before !== null && (!Number.isFinite(before) || before <= cents)) throw new Error('O preço anterior precisa ser maior que o preço atual.');
      const q = new URLSearchParams({
        title: form.title,
        description: form.description,
        item_type: form.item_type,
        tags: form.tags,
        price_cents: String(cents),
        license_type: form.license_type
      });
      if (before !== null) q.set('compare_at_price_cents', String(before));
      const body = new FormData();
      body.append('file', file);
      const r = await authFetch(`${BACKEND_URL}/api/store/listings/upload?${q}`, {
        method: 'POST',
        body
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(typeof d.detail === 'string' ? d.detail : 'Não foi possível criar o anúncio.');
      onPublished(d);
    } catch (e) {
      setNotice(e.message);
    } finally {
      setBusy(false);
    }
  };
  return <section className="store-subpage store-sell"><div className="store-subheading"><span><i className="ti ti-sparkles" /></span><div><small>ATELIÊ DA LOJINHA</small><h2>O que você quer vender?</h2></div></div><form onSubmit={submit}><div className="store-kind-picker">{FILTERS.slice(1).map(([id, label, icon]) => <button type="button" key={id} className={form.item_type === id ? 'active' : ''} onClick={() => change('item_type', id)}><i className={`ti ${icon}`} />{label}</button>)}</div><label className="store-file"><input type="file" required onChange={e => setFile(e.target.files?.[0] || null)} accept={form.item_type === 'image' ? 'image/*' : form.item_type === 'video' ? 'video/mp4,video/webm' : '.glb,.gltf'} /><i className="ti ti-cloud-upload" /><b>{file ? file.name : 'Escolher arquivo'}</b><small>Este arquivo pertence apenas ao anúncio da loja.</small></label><label>Título<input required maxLength="120" value={form.title} onChange={e => change('title', e.target.value)} placeholder="Nome da criação" /></label><label>Descrição<textarea maxLength="2400" value={form.description} onChange={e => change('description', e.target.value)} placeholder="Conte a história, o que está incluso e as condições..." /></label><div className="store-form-row"><label>Preço (R$)<input required inputMode="decimal" value={form.price} onChange={e => change('price', e.target.value.replace(/[^0-9,.]/g, ''))} placeholder="25,00" /></label><label>Licença<select value={form.license_type} onChange={e => change('license_type', e.target.value)}><option value="personal">Uso pessoal</option><option value="commercial">Uso comercial</option><option value="exclusive">Exclusiva</option></select></label></div><label>Tags<input value={form.tags} onChange={e => change('tags', e.target.value)} placeholder="anime, blender, personagem" /></label>{notice && <p className="store-notice">{notice}</p>}<button className="store-submit" disabled={busy || !file}>{busy ? 'Arrumando a prateleira...' : <><i className="ti ti-shopping-bag-plus" />Publicar na lojinha</>}</button></form></section>;
}
function StoreProfile({
  authFetch,
  currentUser,
  getMediaUrl,
  refreshKey,
  onOpenProfile,
  onOpenListing
}) {
  const profileKey = `blop-store-profile-${currentUser.user_id}`;
  const cached = () => {
    try {
      return JSON.parse(sessionStorage.getItem(profileKey) || 'null');
    } catch (_) {
      return null;
    }
  };
  const makeForm = d => ({
    display_name: d.profile.display_name || d.profile.name || '',
    description: d.profile.description || '',
    specialties: (d.profile.specialties || []).join(', '),
    tools: d.profile.tools || [],
    theme: d.profile.theme || 'violet',
    accepts_commissions: Boolean(d.profile.accepts_commissions)
  });
  const [data, setData] = useState(cached);
  const [form, setForm] = useState(() => {
    const d = cached();
    return d ? makeForm(d) : null;
  });
  const [editing, setEditing] = useState(false);
  const [notice, setNotice] = useState('');
  const [coverBusy, setCoverBusy] = useState(false);
  const [coverToCrop, setCoverToCrop] = useState(null);
  const load = useCallback(async () => {
    try {
      const r = await authFetch(`${BACKEND_URL}/api/store/profile/${currentUser.user_id}`);
      const d = await r.json().catch(() => null);
      if (!r.ok || !d) throw new Error(typeof d?.detail === 'string' ? d.detail : 'A vitrine não respondeu.');
      sessionStorage.setItem(profileKey, JSON.stringify(d));
      setData(d);
      setForm(makeForm(d));
      setNotice('');
    } catch (e) {
      setNotice(e.message);
    }
  }, [authFetch, currentUser.user_id, profileKey, refreshKey]);
  useEffect(() => {
    load();
  }, [load]);
  const save = async () => {
    const q = new URLSearchParams({
      ...form,
      tools: form.tools.join(','),
      accepts_commissions: String(form.accepts_commissions)
    });
    const r = await authFetch(`${BACKEND_URL}/api/store/profile?${q}`, {
      method: 'PUT'
    });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) {
      setNotice(typeof d.detail === 'string' ? d.detail : 'Não foi possível salvar.');
      return;
    }
    setEditing(false);
    setNotice('Vitrine atualizada.');
    load();
  };
  const uploadCover = async file => {
    if (!file) return;
    if (!file.type.startsWith('image/')) {
      setNotice('Escolha uma imagem para a capa.');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      setNotice('A capa pode ter no máximo 5 MB.');
      return;
    }
    setCoverBusy(true);
    setNotice('Enviando sua capa…');
    try {
      const body = new FormData();
      body.append('cover', file);
      const response = await authFetch(`${BACKEND_URL}/api/store/profile/cover`, {
        method: 'POST',
        body
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(typeof result.detail === 'string' ? result.detail : 'Não foi possível trocar a capa.');
      setData(current => {
        const next = {
          ...current,
          profile: {
            ...current.profile,
            cover_url: result.cover_url
          }
        };
        sessionStorage.setItem(profileKey, JSON.stringify(next));
        return next;
      });
      setNotice('Capa atualizada. ✦');
    } catch (error) {
      setNotice(error.message);
    } finally {
      setCoverBusy(false);
    }
  };
  if (!data || !form) return <div className="store-profile-loading"><img src="/blop-mini.png" alt="" /><span>Arrumando sua vitrine…</span>{notice && <><small>{notice}</small><button onClick={load}>Tentar novamente</button></>}</div>;
  const p = data.profile;
  const toggleTool = id => setForm({
    ...form,
    tools: form.tools.includes(id) ? form.tools.filter(x => x !== id) : [...form.tools, id]
  });
  return <section className={`store-subpage store-profile store-theme-${p.theme || 'violet'}`}><div className={`store-profile-cover ${p.cover_url ? 'has-custom-cover' : ''}`} style={p.cover_url ? {
      backgroundImage: `linear-gradient(rgba(8,7,13,.08),rgba(8,7,13,.5)),url(${getMediaUrl(p.cover_url)})`
    } : undefined} aria-hidden="true"><i>✦</i><i>♡</i><i>◌</i></div><div className="store-profile-hero"><button className="store-profile-avatar" onClick={() => onOpenProfile?.(p.user_id)}>{p.picture ? <img src={userPictureUrl(p.picture, getMediaUrl)} alt="" /> : <i className="ti ti-user" />}</button><div><small>VITRINE DE</small><h2>{p.display_name || p.name}</h2><button className="store-social-link" onClick={() => onOpenProfile?.(p.user_id)}>@{p.handle} · ver perfil e seguir</button></div><button onClick={() => setEditing(!editing)} aria-label="Editar vitrine"><i className={`ti ${editing ? 'ti-x' : 'ti-pencil'}`} /><span>{editing ? 'Fechar' : 'Decorar'}</span></button></div>{editing ? <div className="store-profile-form"><label className="store-cover-picker"><input type="file" accept="image/*" disabled={coverBusy} onChange={event => { const file=event.target.files?.[0]; event.target.value=''; if(file)setCoverToCrop(file); }} /><span><i className={`ti ${coverBusy ? 'ti-loader-2' : 'ti-photo-edit'}`} /><b>{coverBusy ? 'Enviando capa…' : p.cover_url ? 'Trocar imagem da capa' : 'Escolher imagem da capa'}</b><small>Uma imagem horizontal de até 5 MB fica mais bonita.</small></span></label><label>Nome da vitrine<input value={form.display_name} onChange={e => setForm({
          ...form,
          display_name: e.target.value
        })} /></label><label>O que você cria<textarea value={form.description} onChange={e => setForm({
          ...form,
          description: e.target.value
        })} /></label><label>Palavras da sua arte<input value={form.specialties} onChange={e => setForm({
          ...form,
          specialties: e.target.value
        })} /></label><div className="store-theme-picker"><b>Clima da vitrine</b>{['violet', 'rose', 'ocean', 'forest', 'midnight'].map(x => <button key={x} className={form.theme === x ? 'active' : ''} onClick={() => setForm({
          ...form,
          theme: x
        })} aria-label={x} />)}</div><div className="store-tool-picker"><b>Programas que uso</b><div>{SOFTWARE.map(([id, name, mark]) => <button key={id} className={form.tools.includes(id) ? 'active' : ''} onClick={() => toggleTool(id)}><i>{mark}</i><span>{name}</span></button>)}</div></div><label className="store-check"><input type="checkbox" checked={form.accepts_commissions} onChange={e => setForm({
          ...form,
          accepts_commissions: e.target.checked
        })} />Aceito encomendas</label>{notice && <p className="store-notice">{notice}</p>}<button className="store-submit" onClick={save}>Salvar decoração</button></div> : <><p className="store-profile-bio">{p.description || 'Esse cantinho ainda está esperando uma apresentação.'}</p>{p.tools?.length > 0 && <div className="store-tools"><small>FERRAMENTAS DO ARTISTA</small><div>{SOFTWARE.filter(([id]) => p.tools.includes(id)).map(([id, name, mark]) => <span key={id} title={name}><i>{mark}</i>{name}</span>)}</div></div>}<div className="store-specialties">{(p.specialties || []).map(tag => <span key={tag}>#{tag}</span>)}{p.accepts_commissions && <span className="commissions"><i className="ti ti-sparkles" /> encomendas abertas</span>}</div><div className="store-shelf-title"><span>Minha prateleira</span><small>{data.listings.length} {data.listings.length === 1 ? 'item' : 'itens'}</small></div><div className="store-profile-listings store-product-shelf">{data.listings.length ? data.listings.map(x => <article key={x.listing_id} role="button" tabIndex="0" onClick={() => onOpenListing?.(x)} onKeyDown={event => event.key === 'Enter' && onOpenListing?.(x)}><img src={getMediaUrl(x.thumbnail_url || x.media_url)} alt={x.title} /><div><b>{x.title}</b><small>{x.description || 'Criação do ateliê'}</small>{x.compare_at_price_cents && <del>{money(x.compare_at_price_cents)}</del>}<strong>{money(x.price_cents)}</strong></div></article>) : <div className="store-empty-shelf"><span>♡</span><p>Quando você publicar algo para vender, ele aparece aqui.</p></div>}</div></>}{coverToCrop&&<ImageCropper file={coverToCrop} title="Ajustar capa da vitrine" aspect={16/6} fixedAspect outputWidth={1800} onCancel={()=>setCoverToCrop(null)} onConfirm={file=>{setCoverToCrop(null);uploadCover(file);}}/>}</section>;
}
function MoneyPanel({ authFetch }) {
  const [data, setData] = useState(null);
  const [notice, setNotice] = useState('');
  const [connecting, setConnecting] = useState(false);
  const load = useCallback(async () => {
    setNotice('');
    try {
      const r = await authFetch(`${BACKEND_URL}/api/store/monetization`);
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(typeof d.detail === 'string' ? d.detail : 'Não foi possível abrir suas vendas.');
      setData(d);
    } catch (e) { setNotice(e.message); }
  }, [authFetch]);
  useEffect(() => { load(); }, [load]);
  const connectAccount = async () => {
    setConnecting(true);
    setNotice('');
    try {
      const response = await authFetch(`${BACKEND_URL}/api/store/payments/connect`);
      const result = await response.json().catch(() => ({}));
      if (!response.ok || !result.authorization_url) {
        throw new Error(typeof result.detail === 'string' ? result.detail : 'Não foi possível iniciar a conexão.');
      }
      window.location.assign(result.authorization_url);
    } catch (error) {
      setNotice(error.message || 'Não foi possível iniciar a conexão.');
      setConnecting(false);
    }
  };
  if (!data) return <div className="store-profile-loading"><img src="/blop-mini.png" alt="" /><span>Contando as estrelinhas…</span>{notice && <><small>{notice}</small><button onClick={load}>Tentar novamente</button></>}</div>;
  const connected = data.account?.status === 'connected';
  return <section className="store-subpage store-money">
    <div className="store-subheading"><span><i className="ti ti-wallet" /></span><div><small>SEU CANTINHO FINANCEIRO</small><h2>Vendas e compras</h2></div></div>
    <div className={`store-money-status ${connected ? 'connected' : ''}`}>
      <div><i className={`ti ${connected ? 'ti-circle-check' : 'ti-lock-heart'}`} /><span>
        <b>{connected ? 'Mercado Pago conectado' : 'Conecte sua conta de vendas'}</b>
        <small>{connected ? 'Sua conta do Mercado Pago está vinculada.' : data.provider_configured ? 'Autorize o BlopBoru pelo Mercado Pago para preparar seus recebimentos.' : 'A integração aguarda as credenciais oficiais do Mercado Pago.'}</small>
      </span></div>
      <button onClick={connectAccount} disabled={!data.provider_configured || connected || connecting || !data.seller_eligible}>
        {connecting ? 'Conectando…' : connected ? 'Conectado' : 'Conectar Mercado Pago'}
      </button>
    </div>
    {notice && <p className="store-notice" role="status">{notice}</p>}
    <div className="store-fee-note"><span><i className="ti ti-sparkles" /><b>{data.platform_fee_percent}%</b></span><p>Comissão proposta do BlopBoru por venda aprovada. O checkout continuará fechado até concluirmos os testes e as regras de compra.</p></div>
    <div className="store-order-columns">
      <div><h3>Minhas vendas <small>{data.sales.length}</small></h3>{data.sales.length ? data.sales.map(x => <article key={x.order_id}><span><b>{x.title_snapshot}</b><small>{x.status}</small></span><strong>{money(x.seller_amount_cents)}</strong></article>) : <p>Ainda não há vendas. Sua primeira estrelinha vai aparecer aqui.</p>}</div>
      <div><h3>Minhas compras <small>{data.purchases.length}</small></h3>{data.purchases.length ? data.purchases.map(x => <article key={x.order_id}><span><b>{x.title_snapshot}</b><small>@{x.seller_handle} · {x.status}</small></span><strong>{money(x.amount_cents)}</strong></article>) : <p>As obras compradas formarão sua biblioteca particular.</p>}</div>
    </div>
  </section>;
}
export default function Marketplace({
  authFetch,
  getMediaUrl,
  currentUser,
  onExitStore,
  onOpenProfile
}) {
  const initialItems = () => {
    try {
      return JSON.parse(sessionStorage.getItem('blop-store-items') || '[]');
    } catch (_) {
      return [];
    }
  };
  const connectResult = new URLSearchParams(window.location.search).get('store_connect');
  const [tab, setTab] = useState(() => connectResult ? 'money' : 'home');
  const [items, setItems] = useState(initialItems);
  const [query, setQuery] = useState('');
  const [kind, setKind] = useState('all');
  const [searchOpen, setSearchOpen] = useState(false);
  const [loading, setLoading] = useState(() => initialItems().length === 0);
  const [selected, setSelected] = useState(null);
  const [chatPerson, setChatPerson] = useState(null);
  const [profileRefresh, setProfileRefresh] = useState(0);
  const timer = useRef();
  useEffect(() => {
    if (!connectResult) return;
    const messages = {
      connected: 'Conta do Mercado Pago conectada. Os pagamentos ainda estão em fase de preparação.',
      cancelled: 'Conexão cancelada. Você pode tentar novamente quando quiser.',
      expired: 'Esse link de conexão expirou. Inicie a conexão novamente.',
      error: 'Não foi possível concluir a conexão. Tente novamente mais tarde.'
    };
    window.dispatchEvent(new CustomEvent('blop:notice', { detail: messages[connectResult] || messages.error }));
    const url = new URL(window.location.href);
    url.searchParams.delete('store_connect');
    window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
  }, [connectResult]);
  const load = useCallback(() => {
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      if (!items.length) setLoading(true);
      try {
        const clean = query.trim();
        const r = await authFetch(`${BACKEND_URL}/api/store/listings?search=${encodeURIComponent(clean)}&item_type=${kind}`);
        const d = await r.json();
        const next = Array.isArray(d) ? d : [];
        setItems(next);
        if (!clean && kind === 'all') sessionStorage.setItem('blop-store-items', JSON.stringify(next));
        if (clean.length >= 2) authFetch(`${BACKEND_URL}/api/marketplace/interest?query=${encodeURIComponent(clean)}`, {
          method: 'POST'
        }).catch(() => {});
      } catch (_) {
        if (!items.length) setItems([]);
      } finally {
        setLoading(false);
      }
    }, query ? 350 : 0);
  }, [query, kind, authFetch, items.length]);
  useEffect(() => {
    if (tab === 'home') load();
    return () => clearTimeout(timer.current);
  }, [load, tab]);
  const favorite = async item => {
    const r = await authFetch(`${BACKEND_URL}/api/store/listings/${item.listing_id}/favorite`, {
      method: 'POST'
    });
    const d = await r.json().catch(() => ({}));
    if (r.ok) {
      setItems(old => old.map(x => x.listing_id === item.listing_id ? {
        ...x,
        ...d
      } : x));
      setSelected(old => old?.listing_id === item.listing_id ? {
        ...old,
        ...d
      } : old);
    }
  };
  const openSellerChat = async () => {
    const seller = selected?.seller;
    if (!seller) return;
    const r = await authFetch(`${BACKEND_URL}/api/store/contact/${seller.user_id}`, {
      method: 'POST'
    });
    const d = await r.json().catch(() => ({}));
    if (!r.ok) {
      window.dispatchEvent(new CustomEvent('blop:notice', {
        detail: typeof d.detail === 'string' ? d.detail : 'Não foi possível falar com o artista.'
      }));
      return;
    }
    setChatPerson({
      ...seller,
      ...d
    });
    setSelected(null);
    setTab('chat');
  };
  const published = item => {
    setItems(old => [item, ...old]);
    setProfileRefresh(x => x + 1);
    setTab('home');
    window.dispatchEvent(new CustomEvent('blop:notice', {
      detail: 'Seu anúncio ganhou uma prateleira própria!'
    }));
  };
  return <section className="marketplace-page animate-fade-up"><div className="marketplace-shop-tools">{tab === 'home' && <button className={searchOpen ? 'active' : ''} onClick={() => setSearchOpen(x => !x)}><i className={`ti ${searchOpen ? 'ti-x' : 'ti-search'}`} /><span>{searchOpen ? 'Fechar busca' : 'Pesquisar na lojinha'}</span></button>}</div>{tab === 'home' ? <>{searchOpen && <div className="marketplace-search marketplace-search-open"><i className="ti ti-search" /><input autoFocus value={query} onChange={e => setQuery(e.target.value)} maxLength="100" placeholder="Arte, artista ou personagem..." /></div>}<nav className="marketplace-filters">{FILTERS.map(([id, label, icon]) => <button key={id} className={kind === id ? 'active' : ''} onClick={() => setKind(id)}><i className={`ti ${icon}`} />{label}</button>)}</nav><div className="marketplace-heading"><div><b>{query ? 'Resultados' : 'Para você'}</b><small>{query ? 'Achados para a sua busca' : 'Escolhas do seu cantinho criativo'}</small></div></div>{loading ? <div className="marketplace-loading"><i className="ti ti-loader-2" /></div> : items.length ? <div className="store-grid">{items.map(item => <StoreCard key={item.listing_id} item={item} getMediaUrl={getMediaUrl} onOpen={setSelected} onFavorite={favorite} />)}</div> : <div className="marketplace-empty marketplace-empty-cute"><div className="marketplace-empty-mascot"><span>♡</span><img src="/blop-mini.png" alt="Mascote BlopBoru" /><span>✦</span></div><div className="marketplace-empty-note"><b>As prateleiras estão tirando uma soneca</b><small>O primeiro anúncio vai acordar a lojinha.</small></div></div>}</> : tab === 'sell' ? <SellPanel authFetch={authFetch} onPublished={published} /> : tab === 'chat' ? <PrivateChat authFetch={authFetch} currentUser={currentUser} getMediaUrl={getMediaUrl} onOpenProfile={onOpenProfile} initialPerson={chatPerson} /> : tab === 'money' ? <MoneyPanel authFetch={authFetch} /> : <StoreProfile authFetch={authFetch} currentUser={currentUser} getMediaUrl={getMediaUrl} refreshKey={profileRefresh} onOpenProfile={onOpenProfile} onOpenListing={setSelected} />}<nav className="store-dock"><button className={tab === 'home' ? 'active' : ''} onClick={() => {
        setTab('home');
        load();
      }}><i className="ti ti-building-store" /><span>Lojinha</span></button><button className={tab === 'sell' ? 'active' : ''} onClick={() => setTab('sell')}><i className="ti ti-shopping-bag-plus" /><span>Vender</span></button><button className={tab === 'money' ? 'active' : ''} onClick={() => setTab('money')}><i className="ti ti-wallet" /><span>Vendas</span></button><button className={tab === 'chat' ? 'active' : ''} onClick={() => {
        setChatPerson(null);
        setTab('chat');
      }}><i className="ti ti-message-heart" /><span>Conversas</span></button><button className={tab === 'profile' ? 'active' : ''} onClick={() => setTab('profile')}><i className="ti ti-user-star" /><span>Vitrine</span></button></nav>{selected && <ListingDetails item={selected} authFetch={authFetch} getMediaUrl={getMediaUrl} currentUser={currentUser} onClose={() => setSelected(null)} onFavorite={favorite} onChat={openSellerChat} onOpenProfile={onOpenProfile} onDeleted={id => setItems(old => old.filter(x => x.listing_id !== id))} />}</section>;
}
